@use "variables" as *;

.image {
  max-width: 50%;
  margin-bottom: $spacing-m;
}

.imageOrder {
  max-width: 44%;
  margin-bottom: $spacing-m;
}
